
<div class="accept-container">
  <mat-card class="accept-card">
    <mat-card-header>
      <div mat-card-avatar class="avatar-icon">
        <mat-icon>mail_outline</mat-icon>
      </div>
      <mat-card-title>Workspace Invitation</mat-card-title>
      <mat-card-subtitle>You've been invited to join a workspace</mat-card-subtitle>
    </mat-card-header>

    <mat-card-content>
      @if (isLoading) {
        <div class="loading-state">
          <mat-spinner diameter="40"></mat-spinner>
          <p>Joining workspace...</p>
        </div>
      } @else if (isSuccess) {
        <div class="success-state">
          <mat-icon class="success-icon">check_circle</mat-icon>
          <h3>Welcome aboard!</h3>
          <p>Redirecting you to the workspace home...</p>
        </div>
      } @else if (error) {
        <div class="error-state">
          <mat-icon class="error-icon">error_outline</mat-icon>
          <p>{{ error }}</p>
        </div>
      } @else {
        <div class="invite-details">
          <p>Please confirm that you want to join this workspace.</p>
        </div>
      }
    </mat-card-content>

    <mat-card-actions>
      @if (!isLoading && !isSuccess && !error) {
        <button mat-flat-button color="primary" class="accept-button" (click)="onAccept()">Accept Invitation</button>
      }
      @if (error) {
          <a mat-button color="primary" routerLink="/">Go Home</a>
      }
    </mat-card-actions>
  </mat-card>
</div>
